
import { createI18n } from 'vue-i18n'
const i18nWaterMark = createI18n({
    locale:'en',
    messages: {
        en:require('./en'),
        cs:require('./cs'),
        da:require('./da'),
        de:require('./de'),
        el:require('./el'),
        es:require('./es'),
        fi:require('./fi'),
        fr:require('./fr'),
        hu:require('./hu'),
        ja:require('./ja'),
        it:require('./it'),
        ja:require('./ja'),
        nl:require('./nl'),
        no:require('./no'),
        pl:require('./pl'),
        pt:require('./pt'),
        ru:require('./ru'),
        sv:require('./sv'),
        tr:require('./tr'),
        "zh-TW":require('./zh-TW'),
    }
})
window.i18nWaterMark=i18nWaterMark
export default i18nWaterMark;